import { isEqual } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { session } from '../../../../services/session';
import productService from '../product-service';
import { formatValue } from '../../../base/common/utils';
import { Loader, NoResult } from '../../../misc/loader-utils';

import Product from '../cart-explorer/product';

import { getCartSiblings } from '../cart-explorer/cart-explorer-mocks';

class CartSiblings extends Component {
  constructor(props) {
    super(props);

    this.service = productService;
    this.query = null;

    this.state = {
      loading: true,
      showNoResult: false,
      stats: {},
    };
  }

  componentDidMount() {
    if (this.props.product) {
      this.queryCartData();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.product, this.props.product) ||
      !isEqual(prevProps.currentDateRange, this.props.currentDateRange)
    ) {
      this.queryCartData();
    }
  }

  queryCartData() {
    this.setState({
      loading: true,
      showNoResult: false,
    });
    this.query = this.props.product.product_name;

    const params = {
      ...this.props.params,
      merch_id: this.props.product.merch_id,
      product_name: this.props.product.product_name,
      date_range: this.props.currentDateRange,
    };

    return this.service
      .queryCartData(this.props.pubId, params)
      .then(cartData => {
        // If a more recent call for cart has been made, return without modifying state
        if (this.query !== params.product_name) return;

        if (!cartData.stats.length) {
          this.showNoResult();
        } else {
          this.setState({
            stats: cartData,
            loading: false,
            showNoResult: false,
          });
        }
      })
      .catch(err => {
        this.showNoResult();
      });
  }

  showNoResult() {
    this.setState({
      loading: false,
      showNoResult: true,
    });
  }

  setMockData() {
    this.setState({
      stats: getCartSiblings()[0],
      showNoResult: false,
    });
  }

  render() {
    const { stats } = this.state;
    const products = this.state.stats.stats;
    const cartStats = stats.cart_summary;

    const mocksButton = session.isAdminView ? (
      <button className="mocks-btn" onClick={this.setMockData.bind(this)}>
        Mocks
      </button>
    ) : null;

    const cartSiblings =
      !this.state.loading && !this.state.showNoResult
        ? products.map((product, i) => (
            <Product
              key={i}
              product={product}
              trackLinkOut={this.props.trackLinkOut}
              currentTab="all"
              type="product-research-siblings"
              logoUrl={this.props.logoMap[product.merch_id]}
            />
          ))
        : null;

    const totals =
      !this.state.loading && !this.state.showNoResult ? (
        <>
          <span className="cart-total-units">
            <label>Products purchased with</label>
            <span>{formatValue(cartStats.total_bought_with)}</span>
          </span>
          <span className="cart-aov">
            <label>Average Cart Value</label>
            <span>{formatValue(cartStats.aov, 'currency')}</span>
          </span>
        </>
      ) : null;

    const productCartTotals =
      this.props.type === 'product-research' ? <div className="totals">{totals}</div> : totals;

    return (
      <div className="cart">
        <div className="header">
          <h3>What else is in their cart?</h3>
          {mocksButton}
          {productCartTotals}
        </div>
        <Loader loading={this.state.loading} />
        <NoResult type="cart-explorer" noResult={!this.state.loading && this.state.showNoResult} />
        <div className={`cart-siblings ${this.props.scrollable}`}>{cartSiblings}</div>
      </div>
    );
  }
}

export default withRouter(CartSiblings);
